import React, { Component } from 'react'
import styled from 'styled-components'
import { PageWrapper, Header, XXLText, Card, Button, TextArea, Toast, Error } from '../components'
import axios from 'axios'
import Cookies from 'js-cookie'
import { Formik, Form, Field } from 'formik'
import { feedBackValidator } from '../utlis/validators'
import { API_URL } from '../constants'
import { get } from 'lodash'

const StyledPage = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 60px 0 0 0;
`
const FormikForm = styled(Form)`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`
class Feedback extends Component {
  state = { openToast: false, isLoading: false, error: '' }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.props.history.goBack()
  }
  render() {
    const { openToast, isLoading, error } = this.state
    return (
      <React.Fragment>
        <Header
          title={'Give Us Feedback'}
          icon="arrowBack"
          onClickBack={() => this.props.history.replace('/user-profile')}
          color="#fff"
        />
        <StyledPage viewPadding="24px 16px" height="50px">
          <div>
            <XXLText color="124b5f" textAlign="left">
              Tell us about your experience
            </XXLText>
            <Formik
              enableReinitialize
              initialValues={{
                text: ''
              }}
              validate={feedBackValidator}
              validateOnChange
              onSubmit={async (values, { resetForm }) => {
                this.setState({ isLoading: true, error: '' })
                try {
                  await axios.post(`${API_URL}/UserFeedbacks`, {
                    userId: Cookies.get('user_id'),
                    type: 'Feedback',
                    extra_one: values.text
                  })
                  await this.setState({ isLoading: false, openToast: true })
                  resetForm()
                } catch (error) {
                  this.setState({ isLoading: false, error: get(error.response, 'data.error.message', '') })
                }
              }}
              render={formikBag => (
                <FormikForm>
                  <Card
                    boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                    borderRadius="5px"
                    bgColor="#fff"
                    margin="10px 0"
                    padding="20px 14px">
                    <Field
                      name="text"
                      render={({ field }) => (
                        <TextArea {...field} required error={formikBag.errors.text} paddingTop="40px" />
                      )}
                    />
                  </Card>
                  <Button
                    volume="filled"
                    type="submit"
                    label="Submit"
                    namespace="Feedback"
                    isLoading={isLoading}
                    disabled={isLoading}
                  />
                  <Error response>{error}</Error>
                </FormikForm>
              )}
            />
          </div>
        </StyledPage>
        <Toast open={openToast} message="Your feedback is recorded with us" slideFromTop onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default Feedback



// WEBPACK FOOTER //
// ./src/pages/Feedback.js